<template>
  <input
    type="tel"
    class="ANumberInput"
    v-number="{ precision, decimal, thousands, prefix, suffix, allowDecimal }"
    :class="size"
    :value="formattedValue"
    v-on:input="handleChange"
    @keyup.enter="handleEnter"
  />
</template>

<script>
import number from "@/common/directive/number";
import defaults from "@/common/function/numberoptions";
import { format, unformat } from "@/common/function/numberutils";

export default {
  name: "ANumberInput",
  directives: { number },
  data() {
    return {
      formattedValue: "",
    };
  },
  props: {
    value: {
      required: true,
      default: "",
    },
    masked: {
      type: Boolean,
      default: false,
    },
    precision: {
      type: Number,
      default: () => defaults.precision,
    },
    decimal: {
      type: String,
      default: () => defaults.decimal,
    },
    thousands: {
      type: String,
      default: () => defaults.thousands,
    },
    prefix: {
      type: String,
      default: () => defaults.prefix,
    },
    suffix: {
      type: String,
      default: () => defaults.suffix,
    },
    allowDecimal: {
      type: Boolean,
      default: () => defaults.allowDecimal,
    },
    size: {
      type: String,
      default: "tiny",
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue === oldValue) {
          return;
        }
        let opts = Object.assign({}, this.$props);
        if (!newValue) {
          newValue = "";
        }
        if (opts.allowDecimal) {
          let strValue = newValue.toString();
          let arValue = strValue.split(".");
          if (arValue.length === 2) {
            opts.precision = arValue[1].length;
          }
        }
        var formatted = format(newValue, opts);

        if (formatted === this.formattedValue) {
          return;
        }
        this.formattedValue = formatted;
      },
    },
  },
  methods: {
    handleChange(evt) {
      //수동 입력으로 인한 이벤트가 아니라면 이벤트 없음
      if (!evt.inputType) {
        return;
      }
      let value = this.masked
        ? evt.target.value
        : unformat(evt.target.value, this.precision, this.allowDecimal);
      this.$emit("input", value);
      this.$emit("change", value);
    },
    handleEnter(evt) {
      this.$emit("enter", evt);
    },
  },
};
</script>
